import { Select, SelectProps } from '@braskai/ui-kit';
import { ControllerProps, FieldPath, FieldValues } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../Form';

type FormSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  {
    label: string;
    children?: SelectProps['children'];
    disabled?: boolean;
    isMenuInModal?: SelectProps['isMenuInModal'];
    options: SelectProps['options'];
    placeholder?: string;
    renderValue?: SelectProps['renderValue'];
    sx?: SelectProps['sx'];
  } & ControllerProps<TFieldValues, TName>,
  'render'
>;

export const FormSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  label,
  name,
  children,
  control,
  disabled,
  isMenuInModal,
  placeholder,
  renderValue,
  sx,
}: FormSelectProps<TFieldValues, TName>) => {
  return (
    <FormField
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Select
              disabled={disabled}
              error={!!error}
              isMenuInModal={isMenuInModal}
              placeholder={placeholder}
              renderValue={renderValue}
              sx={sx}
              {...field}
            >
              {children}
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      control={control}
    />
  );
};
